/*!
 * From https://www.redblobgames.com/plotter/1925-delaunator-animation/
 * Copyright 2023 Red Blob Games <redblobgames@gmail.com>
 * @license Apache-2.0 <https://www.apache.org/licenses/LICENSE-2.0.html>
 */

// https://developer.mozilla.org/en-US/docs/Using_files_from_web_applications
export function setUpImageDrop(selector, callback) {
    let dropbox = document.querySelector(selector);
    dropbox.addEventListener('dragenter', handleDragEnter, false);
    dropbox.addEventListener('dragover', handleDragOver, false);
    dropbox.addEventListener('dragleave', handleDragLeave, false);
    dropbox.addEventListener('drop', handleDrop, false);
    function handleDragEnter(e) {
        e.stopPropagation();
        e.preventDefault();
        let item = e.dataTransfer.items[0];
        dropbox.className = (item.kind === 'file' && item.type.startsWith("image/")) ? "dragging dragging-good" : "dragging dragging-bad";
    }
    function handleDragOver(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    function handleDragLeave(e) {
        // NOTE: leave will fire if the mouse goes over a child
        // element, and as far as I can tell, the only way to prevent
        // that is to use pointer-events:none on the child
        e.stopPropagation();
        e.preventDefault();
        dropbox.className = "";
    }
    function handleDrop(e) {
        e.stopPropagation();
        e.preventDefault();
        dropbox.className = "";

        let item = e.dataTransfer.items[0];
        if (item.kind != 'file') {
            console.log("Not a file:", item.kind);
            return;
        }
        if (!item.type.startsWith("image/")) {
            console.log("Not an image file:", item.type);
            return;
        }
        console.log(`handling drop of file kind=${item.kind} type=${item.type}`);
        let reader = new FileReader();
        dropbox.className = "dragging dragging-wait";
        reader.onload = (e) => {
            let img = document.createElement('img');
            img.src = e.target.result;
            img.width = 1024;
            img.height = 1024;
            img.onload = () => {
                dropbox.className = "";
                callback(img);
            };
            document.body.appendChild(img);
        };
        reader.readAsDataURL(e.dataTransfer.files[0]);
    }
}
